import { useState } from 'react';
import Exercise from '../exercise/exercise';
import exercises from './exercisesJson';
import './exercisesList.css';

import { LayoutGroup, motion } from "motion/react"
function ExercisesList({user,loading,app}) {
  return (
    <div className='exercisesContainer'>
      <LayoutGroup>
        <motion.div layout key={'shredieck'}>
          <motion.div layout className='exercisesList'>
            <Exercise loading={loading} app={app} user={user} key={'shredieck'} data={'shredieck'} kind={'shredieck'}/>
          </motion.div>
          </motion.div>
      {
        exercises.map((Es,i)=>
          <motion.div layout key={i} className={i==2||i==7||i==9?'disabled':''}><h4>{Es.title} {i==2||i==7||i==9?<div className='tag'>Coming soon</div>:<></>}</h4>
          {Es.description?<Description text={Es.description}/>:''}
          <motion.div layout className='exercisesList'>
            <LayoutGroup>
          {Es.exercises.map(e=>
            <Exercise loading={loading} app={app} user={user} key={e.id} data={e} kind={Es}/>
          )}
          </LayoutGroup>
          </motion.div>
          </motion.div>
        )
      }
      </LayoutGroup>
    </div>

  );
}
const Description = ({text})=>{
  const [isOpen,setIsOpen] = useState(false);
  return <motion.p className={isOpen?'open':''} layout onClick={()=>setIsOpen(o=>!o)} style={
    isOpen?{
      height:'auto'
    }:{
      height:38
    }
  }>{text} <span>See less</span></motion.p>;
}
export default ExercisesList;